import React from 'react';
import { Link } from 'react-router-dom';

const Home = () => {
  return (
    <div 
      className="h-screen bg-cover bg-center flex flex-col items-center justify-center text-white relative"
      style={{ backgroundImage: "url('/store-bg.jpg')" }} // Change this path
    >
      {/* Overlay for better readability */}
      <div className="absolute inset-0 bg-black bg-opacity-50"></div>

      <div className="relative text-center px-6">
        <h1 className="text-4xl font-bold mb-4">Welcome to Our Online Store</h1>
        <p className="text-lg mb-6">Discover amazing products at the best prices.</p>
        <Link to="/products" className="bg-blue-600 px-6 py-2 rounded-md hover:bg-blue-700">
          Start Shopping
        </Link>
      </div>
    </div>
  );
};

export default Home;
